import { useState } from "react";
import { QRCodeSVG } from "qrcode.react";
import { Copy, QrCode, Info } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { copyText } from "@/lib/api";

const KEY_TYPE = { cpf: "CPF", cnpj: "CNPJ", telefone: "Telefone", email: "E-mail", aleatoria: "Chave aleatória" };

export const PixBar = ({ pix }) => {
  const [open, setOpen] = useState(null);
  const notReady = () => toast.info("O Pix ainda não foi configurado pela igreja.", { id: "pix-not-ready" });
  const copy = async () => {
    if (!pix?.configured) return notReady();
    const ok = await copyText(pix.pix_code);
    ok ? toast.success("Código Pix copiado. Cole no aplicativo do seu banco.") : toast.error("Não foi possível copiar.");
  };
  const show = (mode) => (pix?.configured ? setOpen(mode) : notReady());
  const btn = "flex h-12 min-w-0 flex-1 items-center justify-center gap-1 whitespace-nowrap px-1 text-[13px] font-bold tracking-normal transition-colors active:bg-black/5 min-[400px]:gap-2 min-[400px]:text-[15px] min-[400px]:tracking-wide";
  const ic = "h-4 w-4 shrink-0 min-[400px]:h-5 min-[400px]:w-5";
  return (
    <>
      <div data-testid="pix-bar" className="flex divide-x divide-zap-line border-t border-zap-line bg-white text-zap-deep">
        <button data-testid="pix-info-button" className={btn} onClick={() => show("info")}><Info className={ic} /> PIX</button>
        <button data-testid="pix-contribute-button" className={`${btn} text-zap-gold`} onClick={() => show("qr")}><QrCode className={ic} /> CONTRIBUIR</button>
        <button data-testid="pix-copy-button" className={btn} onClick={copy}><Copy className={ic} /> COPIAR PIX</button>
      </div>
      <Dialog open={!!open} onOpenChange={(v) => !v && setOpen(null)}>
        <DialogContent data-testid="pix-dialog" className="max-w-md">
          <DialogHeader>
            <DialogTitle className="font-display text-2xl text-zap-deep">{open === "qr" ? "Contribuir com Pix" : "Pix da igreja"}</DialogTitle>
            <DialogDescription className="text-base">Igreja Unida Deus Proverá</DialogDescription>
          </DialogHeader>
          {pix?.configured && (
            <div className="space-y-4 text-[16px]">
              {open === "qr" && (
                <div className="flex justify-center rounded-lg border border-zap-line bg-white p-4">
                  <QRCodeSVG data-testid="pix-qr" value={pix.pix_code} size={220} level="M" />
                </div>
              )}
              <dl className="space-y-2">
                {pix.beneficiary_name && <div><dt className="text-sm text-muted-foreground">Favorecido</dt><dd className="font-semibold">{pix.beneficiary_name}</dd></div>}
                {pix.pix_key && <div><dt className="text-sm text-muted-foreground">{KEY_TYPE[pix.pix_key_type] || "Chave"}</dt><dd data-testid="pix-key-value" className="break-all font-mono text-[15px]">{pix.pix_key}</dd></div>}
              </dl>
              {pix.instructions && <p className="whitespace-pre-wrap text-muted-foreground">{pix.instructions}</p>}
              <p className="text-sm text-muted-foreground">Depois de contribuir, envie o comprovante pelo clipe de anexos.</p>
              <Button data-testid="pix-dialog-copy-button" onClick={copy} className="h-12 w-full text-base font-bold"><Copy className="mr-2 h-5 w-5" /> COPIAR CÓDIGO PIX</Button>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};
